// extracted by mini-css-extract-plugin
export default {"container":"styles_container__FtLQ-","menu-button":"styles_menu-button__HDd7C","icon":"styles_icon__svHS8","separator":"styles_separator__OdcLw"};